// extracted by mini-css-extract-plugin
export var tosLink = "_a3-0";